import { useTheme } from "@hooks";
import { IconProps } from "./types";

export const ArrowUpRight = ({ fill: fillProp, size = 7, style }: IconProps) => {
  const { theme } = useTheme();

  const stroke = fillProp ?? theme.icon.default;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 7 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M0.6 5.6L5.6 0.6M0.6 0.6H5.6V5.6"
        stroke={stroke}
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
